import React, { useEffect, useMemo, useState } from "react";
import {
  DialogContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import DialogTitle from "../../../components/dialog-title";
import LoadingComponent from "../../../components/loading";
import cartInquiryService from "../../../services/cart-inquiry.service";
import { dateFormat } from "../../../helpers/date-helpers";
import { currencyFormat } from "../../../helpers";
import { useErrorHandler } from "../../../hooks";

function getCartItemTitle(item) {
  if (item.glassesSizeId) {
    const glass = item.glassesSize?.glassesColor?.glasses;
    return [
      glass?.category === "sunglass" ? "عینک آفتابی" : "عینک طبی",
      glass?.brand?.name,
      glass?.name,
      item.glassesSize?.glassesColor?.name,
      item.glassesSize?.value,
    ]
      .filter(Boolean)
      .join(" - ");
  }

  if (item.accessoryColorId) {
    const accessory = item.accessoryColor?.accessory;
    return [
      accessory?.category?.name || "اکسسوری",
      accessory?.brand?.name,
      accessory?.name,
      item.accessoryColor?.name,
    ]
      .filter(Boolean)
      .join(" - ");
  }

  return "-";
}

export default function CartModal({ close, data }) {
  const [cart, setCart] = useState();
  const errorHandler = useErrorHandler();

  useEffect(() => {
    cartInquiryService.getUserCartDetail(data.id).then(({ data, error }) => {
      if (error) return errorHandler(error);
      setCart(data);
    });
  }, [data.id, errorHandler]);

  const createdDate = useMemo(() => {
    const items = cart?.items || [];
    if (!items.length) return null;
    return items
      .map((item) => item.createDate)
      .filter(Boolean)
      .sort()[0];
  }, [cart]);

  return (
    <>
      <DialogTitle onClose={() => close()}>سبد خرید {data.fullName}</DialogTitle>
      <Divider />
      <DialogContent className="py-3">
        {!cart ? (
          <LoadingComponent />
        ) : (
          <>
            <Typography className="mb-3">
              تاریخ ایجاد سبد: {createdDate ? dateFormat(createdDate) : "-"}
            </Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>محصول</TableCell>
                  <TableCell>عدسی</TableCell>
                  <TableCell align="center">تعداد</TableCell>
                  <TableCell>تخفیف</TableCell>
                  <TableCell>تاریخ افزودن</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {cart.items?.length ? (
                  cart.items.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{getCartItemTitle(item)}</TableCell>
                      <TableCell>{item.coordinatedLens?.lens?.name || "-"}</TableCell>
                      <TableCell align="center">{item.count}</TableCell>
                      <TableCell>
                        {item.discount ? currencyFormat(item.discount) : "-"}
                      </TableCell>
                      <TableCell>{dateFormat(item.createDate)}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      سبد خرید فعالی وجود ندارد.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </>
        )}
      </DialogContent>
    </>
  );
}
